import { convenioService } from "../../../_services/convenios.service";
import { convEstadoService } from "../../../_services/convEstado.service";
import { tipoRetiroService } from "../../../_services/tipoRetiro.service";
import { dashboardConstants } from "../constants";

export const getTipoRetiro = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await tipoRetiroService.getTipoRetiro(data);

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_TIPO_RETIRO, payload: list };
  }
};

export const getConvCaracters = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await convenioService.getConvCaracters(data);

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.CONV_CARACTER, payload: list };
  }
};

export const getConvFormaPagos = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await convenioService.getConvFormaPagos(data);

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.CONV_FORMAPAGOS, payload: list };
  }
};

export const getConvEstado = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await convEstadoService.getConvEstado(data);

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONV_ESTADO, payload: list };
  }
};

export const getConvenios = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await convenioService.getConvenios(data);

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED, payload: { convenios: [] } };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONVENIO_LIST, payload: list };
  }
};


export const getConvenio = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = await convenioService.getConvenio(id);
    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONVENIO, payload: list };
  }
};


export const deleteConvenio = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = await convenioService.deleteConvenio(id);

    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(payload) {
    return { type: dashboardConstants.SET_CONVENIO_LIST, payload };
  }
};

export const editConvenio = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const result = await convenioService.editConvenio(data);

    if (typeof result === "string") {
      dispatch(failure(result));
    } else {
      dispatch(success(result));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    console.error(error);
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(payload) {
    return { type: dashboardConstants.SET_CONVENIO_LIST, payload };
  }
};
